import React from 'react';
import styled from 'styled-components';
import {
  AIPowered,
  EnterpriseGrade,
  TimerRounded,
} from '../../../Common/SvgIcon/CommonSvgIcons';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 60px;
  background: #e6f0f0;
  padding-bottom: 60px;
  width: 100%;
  @media only screen and ${device.tablet} {
    padding-top: 30px;
  }
`;

const Container = styled.div`
  width: 1140px;
  display: flex;
  justify-content: space-between;
  @media only screen and ${device.tablet} {
    flex-direction: column;
    width: 345px;
    gap: 40px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 519px;
`;
const RightSection = styled.div`
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 32px;

  color: #063257;
  text-align: left;
  @media only screen and ${device.tablet} {
    font-size: 28px;
    max-width: 345px;
  }
`;
const Description = styled.div`
  font-family: Inter;
  font-weight: 400;
  margin-top: 20px;
  font-size: 20px;

  color: #006867;
  text-align: left;
  @media only screen and ${device.tablet} {
    font-size: 20px;
    max-width: 345px;
  }
`;
const SignUpButton = styled.div`
  width: 226px;
  gap: 10px;
  border-radius: 10px;
  padding: 20px;
  background: linear-gradient(93.98deg, #0c3f89 0.31%, #4aa373 99.69%);
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;

  text-align: center;
  color: #fafafa;
  margin-top: 40px;
  transition: background 0.3s ease;

  &:hover {
    cursor: pointer;
    background: linear-gradient(93.98deg, #092f6b 0.31%, #3a865e 99.69%);
  }
`;
const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Heading = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;

  vertical-align: middle;
  color: #121212;
  text-align: left;
`;

const Option = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;

  vertical-align: middle;
  max-width: 271px;
  color: #636363;
  text-align: left;
`;

const Options = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  height: 100px;
`;
const SmartBrands = (props) => {
  return (
    <Wrapper>
      <Container>
        <LeftSection>
          <Title>
            Smart brands don’t spend weeks analyzing data - they use AI to get
            instant, actionable insights.
          </Title>
          <Description>
            Marketers, agencies, and brand leaders trust BrandAstra because it’s
            fast, AI-powered, and designed for real-time decision-making.
          </Description>
          <SignUpButton
            onClick={() => {
              props?.setPopupOpen(true);
            }}
          >
            Sign Up for Free
          </SignUpButton>
        </LeftSection>
        <RightSection>
          <Options>
            <div>{TimerRounded}</div>
            <OptionContainer>
              <Heading>Instant Set-Up</Heading>
              <Option>
                No technical skills needed. Get started in minutes.
              </Option>
            </OptionContainer>
          </Options>
          <Options>
            <div>{AIPowered}</div>
            <OptionContainer>
              <Heading>AI-Powered & Free to Start</Heading>
              <Option>Unlock insights at no cost. Scale as you grow. </Option>
            </OptionContainer>
          </Options>
          <Options>
            <div>{EnterpriseGrade}</div>

            <OptionContainer>
              <Heading>Enterprise-Grade Security</Heading>
              <Option>Your data stays encrypted and fully compliant. </Option>
            </OptionContainer>
          </Options>
        </RightSection>
      </Container>
    </Wrapper>
  );
};

export default SmartBrands;
